import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 课程价目列表
  pricingPageList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/pricing/pricingPageList?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },
  // 课程价目详情
  pricingDetail(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/pricing/pricingDetail?${parameterChange(data)}`,
      method: 'get',
    });
  },
  // 课程价目新增
  pricingAdd(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/pricing/pricingAdd`,
      method: 'post',
      data,
    });
  },
  // 课程价目编辑
  pricingUpdate(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/pricing/pricingUpdate`,
      method: 'post',
      data,
    });
  },
  // 课程价目删除
  pricingDelete(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/pricing/pricingDelete`,
      method: 'post',
      data,
    });
  },
};
